// src/hooks/useStories.ts
//
// TanStack Query hook exposing the Stories feed. Today it derives synchronously
// from existing content via buildStories(); the queryFn boundary means it can be
// swapped for a real `fetch('/api/stories')` later with zero changes to callers.

import { useQuery } from '@tanstack/react-query';
import { buildStories } from '@/data/stories/buildStories';
import type { Story } from '@/data/stories/types';

export function useStories() {
  return useQuery<Story[]>({
    queryKey: ['stories'],
    queryFn: async () => buildStories(),
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
